import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function TrendingSection() {
  const trendingArticles = articles.filter((a) => a.isHot).slice(0, 6);

  return (
    <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-2">
              热门爆料
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              全网关注度最高的八卦资讯，实时追踪热点动态
            </p>
          </div>
          <Link
            to="/category/entertainment"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部热门
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {trendingArticles.map((article) => (
            <article key={article.id} className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 hover:shadow-lg">
              <Link to={`/article/${article.slug}`} className="block">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    width="800"
                    height="500"
                  />
                  {article.isVideo && (
                    <div className="absolute inset-0 flex items-center justify-center bg-black/20">
                      <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white/90 text-primary-500">
                        <i className="ri-play-fill text-xl md:text-2xl" />
                      </div>
                    </div>
                  )}
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug mb-3 line-clamp-2 group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <div className="flex items-center gap-3">
                      <span>{article.author}</span>
                      <span>{article.date}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-eye-line" />
                      </span>
                      <span>{article.views.toLocaleString()}</span>
                    </div>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}